import { useRef } from 'react';
import useOnClickOutside from '@/hooks/useOnClickOutside';

function TabbyModal({ total, locale, setShow }) {
  const tabbyRef = useRef(null);
  useOnClickOutside([tabbyRef], () => setShow(false));
  return (
    <div className='fixed top-0 left-0 z-3000 flex h-screen max-h-screen w-screen items-center justify-center overflow-y-auto scrollbar-hide  bg-black/60'>
      <div ref={tabbyRef} className='relative w-[440px] max-[440px]:w-full'>
        <iframe
          // src={`https://checkout.tabby.ai/promos/product-page/installments/${locale}/?price=${total}&currency=SAR&merchant_code=main_website_store_SAR&public_key=${process.env.NEXT_PUBLIC_TABBY_TOKEN}`}
          src={`https://checkout.tabby.ai/promos/product-page/installments/${locale}/?price=${total}&currency=SAR&merchant_code=${process.env.NEXT_PUBLIC_TABBY_CODE}&public_key=${process.env.NEXT_PUBLIC_TABBY_TOKEN}`}
          width='100%'
          height='600px'
          title='Tabby Checkout'
          className='rounded-[32px]'
        />
      </div>
    </div>
  );
}

export default TabbyModal;
